/**
 * ES-module mirror of backend/utils/passwordPolicy.js.
 *
 * The signup form used to require only `min 6` while the register endpoint also
 * required a capital, a small letter and a digit, so a password could pass the
 * form, spend an SMS, and fail after the shopper had already typed the OTP.
 * Keeping the two files identical is what stops that gap reopening.
 */

export const MIN_LENGTH = 6;

// Ordered the way they are shown under the password field.
export const RULES = [
  { id: 'length', label: `At least ${MIN_LENGTH} characters`, test: (v) => v.length >= MIN_LENGTH },
  { id: 'lowercase', label: 'One small letter (a-z)', test: (v) => /[a-z]/.test(v) },
  { id: 'uppercase', label: 'One capital letter (A-Z)', test: (v) => /[A-Z]/.test(v) },
  { id: 'number', label: 'One number (0-9)', test: (v) => /[0-9]/.test(v) }
];

export const EXAMPLE = 'Uddit#2026';

export const REQUIREMENT_MESSAGE =
  `Password must be at least ${MIN_LENGTH} characters and include one capital letter, ` +
  `one small letter and one number (example: ${EXAMPLE})`;

export const failedRules = (value) => {
  const password = typeof value === 'string' ? value : '';
  return RULES.filter((rule) => !rule.test(password));
};

export const isValid = (value) => failedRules(value).length === 0;

/**
 * Yup `.test()` pair for the password field. Used by every signup form so they
 * all reject exactly what the API rejects, and say the same thing about it.
 */
export const yupPasswordTest = ['password-policy', REQUIREMENT_MESSAGE, isValid];
